import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './Dashboard'

function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  return currentUser ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    // <Router>
    //   <AuthProvider>
    //     <Routes>
    //       <Route path="/login" element={<Login />} />
    //       <Route 
    //         path="/" 
    //         element={
    //           <PrivateRoute>
    //             <Dashboard />
    //           </PrivateRoute>
    //         } 
    //       />
    //       <Route path="*" element={<Navigate to="/" replace />} />
    //     </Routes>
    //   </AuthProvider>
    // </Router>
    <div>
      <Dashboard />
      
    </div>
  );
}

export default App;